import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useWeb3Ts } from "../context/Web3TsContext";
import { useAccount } from "./useAccount";
import { useConnect } from "./useConnect";

export const useRefAddress = (props?: { origin?: string }) => {
 const [refAddr, setRefAddr] = useState<string>();
 const { search } = useLocation();
 const { account, isConnected } = useAccount();
 const { connect } = useConnect();
 const { config } = useWeb3Ts();
 useEffect(() => {
  const url = new URLSearchParams(search);
  const refVal = url.get(config.buyContract.referralPath);
  setRefAddr(refVal || undefined);
 }, [search, config.buyContract.referralPath]);

 const referralUrl = useMemo(() => {
  return `${props?.origin || window.location.origin}?${
   config.buyContract.referralPath
  }=${account}`;
 }, [account, config.buyContract.referralPath, props?.origin]);

 const createInvite = async () => {
  if (!isConnected) {
   return connect();
  }
  navigator.clipboard.writeText(referralUrl || "");
  toast.success("Referral code copied successfully", {});
 };

 return { refAddr, referral: referralUrl, createInvite };
};
